import { LoginResponseDto } from '../../pages/auth/models/login-response.dto';
import { AuthSession } from './auth-session.model';

export function mapLoginResponseToSession(
  response: LoginResponseDto,
  login: string,
  loggedAt: Date,
): AuthSession {
  return {
    login,
    accessToken: response.access_token,
    refreshToken: response.refresh_token,
    expiresIn: response.expires_in,
    tokenType: response.token_type,
    scope: response.scope,
    userCode: response.user_code,
    role: response.role,
    tenantId: response.tenant_id,
    tenantName: response.tenant_name,
    schema: response.schema,
    loggedAt: loggedAt.toISOString(),
    accessTokenExpiresAt: new Date(loggedAt.getTime() + response.expires_in * 1000).toISOString(),
    mustChangePassword: response.must_change_password ?? false,
  };
}
